<template>
  <v-app>
    <v-btn
      icon
      @click.stop="isNavigationExpanded = !isNavigationExpanded"
      class="arrow-button"
      :class="isNavigationExpanded ? 'arrow-button-right' : 'arrow-button-left'"
      v-if="isUserLoggedin && !firstTimeLogin && !twoFactorEnabled"
    >
      <v-icon v-if="!isNavigationExpanded">mdi-chevron-left</v-icon>
      <v-icon v-else>mdi-chevron-right</v-icon>
    </v-btn>
    <the-layout-drawer
      v-if="isUserLoggedin && !firstTimeLogin && !twoFactorEnabled"
      @mini="onNavigationExpand"
      :miniValue="isNavigationExpanded"
    />
    <the-layout-toolbar
      v-if="isUserLoggedin && !firstTimeLogin && !twoFactorEnabled"
      :isNavigationExpanded="isNavigationExpanded"
      :class="
        isUserLoggedin
          ? isNavigationExpanded
            ? 'secured-mini-header'
            : 'secured-expanded-header'
          : ''
      "
    />
    <the-layout-footer
      v-if="isUserLoggedin && !firstTimeLogin && !twoFactorEnabled"
      :isNavigationExpanded="isNavigationExpanded"
    />
    <v-main
      :class="
        isUserLoggedin && !firstTimeLogin && !twoFactorEnabled
          ? isNavigationExpanded
            ? 'v-main-secured-mini'
            : 'v-main-secured-expanded'
          : ''
      "
    >
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import TheLayoutDrawer from "./views/layout/TheLayoutDrawer.vue";
import TheLayoutToolbar from "./views/layout/TheLayoutToolbar.vue";
// import TheLayoutContent from './views/layout/TheLayoutContent.vue';
import TheLayoutFooter from "./views/layout/TheLayoutFooter.vue";
// import config from "../src/config";
import store from "../src/store";
import { mapGetters } from "vuex";
import EventBus from "../src/utils/EventBus";
import tokenAuthService from "../src/api/tokenAuthenticationService";
import router from "../src/router";
export default {
  name: "App",
  components: {
    TheLayoutDrawer,
    TheLayoutToolbar,
    // TheLayoutContent,
    TheLayoutFooter,
  },
  computed: {
    ...mapGetters(["firstTimeLogin", "twoFactorEnabled"]),
  },
  data() {
    return {
      isUserLoggedin: false,
      isNavigationExpanded: true,
    };
  },
  created() {
    EventBus.$on("mini", this.onMiniChange);
  },
  beforeDestroy() {
    EventBus.$off("mini", this.onMiniChange);
  },
  methods: {
    onMiniChange(minivalue) {
      this.isNavigationExpanded = minivalue;
      EventBus.$emit("isNavigation", minivalue);
    },
    // setAuthTimers() {
    //   this.refreshInterval = setInterval(() => {
    //     //console.log(config.authTokenInterval);
    //     this.callTokenUpdate();
    //   }, parseInt(config.AUTH_TOKEN_INTERVAL));
    // },
    callTokenUpdate() {
      var refershObject = {
        grant_type: "refresh_token",
        refresh_token: store.getters.refreshToken,
        username: store.getters.user,
      };
      tokenAuthService.getAccessTokenByRefreshToken(
        refershObject,
        (response) => {
          store.commit("SET_ACCESS_TOKEN", response.access_token);
          store.commit("SET_REFRESH_TOKEN", response.refresh_token);
          store.commit("SET_TOKEN_EXPIRY_TIME", response.expires_at);
          // this.$store.commit("updateisTokenRefreshing", false);
        },
        (errorResponse) => {
          console.log(errorResponse);
          // this.$store.commit("updateisTokenRefreshing", false);
          this.$toast.error("Session expired, please kindly login again");
          store.dispatch("LogOut");
          router.push("/signin");
        }
      );
    },
    onNavigationExpand(mini) {
      this.isNavigationExpanded = mini;
      EventBus.$emit("isNavigation", mini);
    },
  },
  watch: {
    isNavigationExpanded() {},
    isUserLoggedin(isLogged) {
      if (isLogged) {
        // this.setAuthTimers();
      }
    },
    $route() {
      //scroll to top of the page
      window.scrollTo(0, 0);
      this.isUserLoggedin = store.getters.token;
      //Resetting manually as app.vue just get remounted even on logout
      if (!this.isUserLoggedin) {
        clearInterval(this.refreshInterval);
        return;
      }
    },
  },
  mounted() {
    this.isUserLoggedin = store.getters.token;
  },
};
</script>
<style scoped lang="scss">
@import "./assets/styles/variables.scss";

.v-main-secured-mini {
  padding: 64px 0px 41px 90px !important;
}
.v-main-secured-expanded {
  padding: 64px 0px 40px 300px !important;
}

.arrow-button {
  top: 55px;
  width: 30px !important;
  height: 30px !important;
  background: $black-shade-3;
  transition: left 0.1s ease-in-out 0s, visibility 0.1s ease-in-out 0s;
  position: fixed;
  box-shadow: rgb(56 58 60) 0px 0px 0px 1px !important;
  z-index: 10;
}

.arrow-button:hover {
  // box-shadow: rgb(214 218 220) 0px 0px 0px 1px !important;
  box-shadow: #e85a37 0px 0px 0px 1px !important;
}

.arrow-button-right {
  left: 73px;
}

.arrow-button-left {
  left: 280px;
}
.mdi-chevron-right,
.mdi-chevron-left {
  font-size: 30px !important;
  color: $neutral-white !important;
}
.footer-mini {
  padding-left: 4em;
}
</style>
